import createIcon from '../../createIcon';

/**
 * @component @name HdrOnSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTguNVYxNy41QzE4IDE2LjcgMTcuMyAxNiAxNi41IDE2SDEzVjIySDE0LjVWMjBIMTUuNkwxNi41IDIySDE4TDE3LjEgMTkuOUMxNy42IDE5LjYgMTggMTkuMSAxOCAxOC41Wk0xNi41IDE4LjVIMTQuNVYxNy41SDE2LjVWMTguNVpNMy41IDE4SDEuNVYxNkgwVjIySDEuNVYxOS41SDMuNVYyMkg1VjE2SDMuNVYxOFpNMTAgMTZINi41VjIySDEwQzEwLjggMjIgMTEuNSAyMS4zIDExLjUgMjAuNVYxNy41QzExLjUgMTYuNyAxMC44IDE2IDEwIDE2Wk0xMCAyMC41SDhWMTcuNUgxMFYyMC41Wk0yNCAyMEgyMlYyMkgyMC41VjIwSDE4LjVWMTguNUgyMC41VjE2LjVIMjJWMTguNUgyNFYyMFpNMTIgNEMxNC4yMSA0IDE2IDUuNzkgMTYgOEMxNiAxMC4yMSAxNC4yMSAxMiAxMiAxMkM5Ljc5IDEyIDggMTAuMjEgOCA4QzggNS43OSA5Ljc5IDQgMTIgNFpNMTIgMkM4LjY5IDIgNiA0LjY5IDYgOEM2IDExLjMxIDguNjkgMTQgMTIgMTRDMTUuMzEgMTQgMTggMTEuMzEgMTggOEMxOCA0LjY5IDE1LjMxIDIgMTIgMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HdrOnSelect = createIcon('HdrOnSelect', [
  [
    'path',
    {
      d: 'M18 18.5V17.5C18 16.7 17.3 16 16.5 16H13V22H14.5V20H15.6L16.5 22H18L17.1 19.9C17.6 19.6 18 19.1 18 18.5ZM16.5 18.5H14.5V17.5H16.5V18.5ZM3.5 18H1.5V16H0V22H1.5V19.5H3.5V22H5V16H3.5V18ZM10 16H6.5V22H10C10.8 22 11.5 21.3 11.5 20.5V17.5C11.5 16.7 10.8 16 10 16ZM10 20.5H8V17.5H10V20.5ZM24 20H22V22H20.5V20H18.5V18.5H20.5V16.5H22V18.5H24V20ZM12 4C14.21 4 16 5.79 16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8C8 5.79 9.79 4 12 4ZM12 2C8.69 2 6 4.69 6 8C6 11.31 8.69 14 12 14C15.31 14 18 11.31 18 8C18 4.69 15.31 2 12 2Z',
      key: '3fraig',
    },
  ],
]);

export default HdrOnSelect;
